export const RATING_TOTAL = 5;
